import { combineReducers } from 'redux'

function width(state: number = window.innerWidth, action: any) {
    switch (action.type) {
        case 'SCREEN_WIDTH':
            return action.width

        default:
            return state
    }
}

import * as authReducers from './auth'
import * as favoritesReducers from './favorites'
import * as headerReducers from '../components/Header/reducers'
import * as loginReducers from '../scenes/Auth/Login/reducers'
import * as registerReducers from '../scenes/Auth/Register/reducers'
import * as articleReducers from '../scenes/Article/reducers'
import * as detailReducers from '../scenes/ArticleDetail/reducers'
import * as authorReducers from '../scenes/Analyst/reducers'
import * as searchReducers from '../scenes/Search/reducers'
import * as searchInputReducers from '../components/SearchInput/reducers'

const reducers = Object.assign(
    {},
    width,
    authReducers,
    favoritesReducers,
    headerReducers,
    loginReducers,
    registerReducers,
    articleReducers,
    detailReducers,
    authorReducers,
    searchReducers,
    searchInputReducers,
)

export default combineReducers(reducers)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/index.tsx